import React, { useMemo } from "react";
import { useDataWithRoute } from "../utils/hooks";
import { VsiBubbleFavs } from "../styled/App.styled";
import { Spinner } from "reactstrap";
import { provisioningColorsNoSnap, formatBarData } from "../utils/chartUtils";
import StackedColumnChart from "../components/StackedColumnChart";
import { numberFormatter } from "../utils/gridFormatters";
import { useVsiAppContext } from "../stores/VsiApp";

const buDefs = [
  {
    "field": "device_type_description",
    "headerName": "Device Type"
  },
  {
    "field": "total_used",
    "type": "numericColumn",
    "headerName": "Total Used",
    "aggFunc": "sum",
    "filter": "agNumberColumnFilter",
    "allowedAggFuncs": [
      "sum"
    ],
    "cellRenderer": numberFormatter
  },
  {
    "field": "provisioned_free",
    "type": "numericColumn",
    "headerName": "Provisioned Free",
    "aggFunc": "sum",
    "filter": "agNumberColumnFilter",
    "allowedAggFuncs": [
      "sum"
    ],
    "cellRenderer": numberFormatter
  },
  {
    "field": "unprovisioned_free",
    "type": "numericColumn",
    "headerName": "Unprovisioned Free",
    "aggFunc": "sum",
    "filter": "agNumberColumnFilter",
    "allowedAggFuncs": [
      "sum"
    ],
    "cellRenderer": numberFormatter
  },
  {
    "field": "overprovisioned",
    "type": "numericColumn",
    "headerName": "Overprovisioned",
    "aggFunc": "sum",
    "filter": "agNumberColumnFilter",
    "allowedAggFuncs": [
      "sum"
    ],
    "cellRenderer": numberFormatter
  }
];

const sortingArr = ["Overprovisioned", "Unprovisioned Free", "Provisioned Free", "Total Used"];

export default function StorageByGroup({ params }) {
  const value = useMemo(() => params?.value ?? "device_type", [params]);
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("STORAGE");

  const route = useMemo(() => `/api/v6/report/enterprise_storage_by_${encodeURIComponent(value)}_proc?client_id=${clientId}&period_id=${periodId}`, [value, clientId, periodId]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  const barData = useMemo(() => {
    return formatBarData(recordset || [], {
      sortingArr,
      sortingField: value,
      defs: buDefs.filter(def => sortingArr.includes(def.headerName))
    });
  }, [recordset, value]);

  return isLoading ? (
    <Spinner size={"lg"} />
  ) : (
    <VsiBubbleFavs>
      <StackedColumnChart categories={barData.categories}
                          height={420}
                          colors={provisioningColorsNoSnap}
                          series={barData.series} />
    </VsiBubbleFavs>
  );
}